export default __webpack_public_path__ + "03e6219408874065807cdab77274231b.png";